import React from 'react'
import "./CommonHeadingBeforeAfterLine.css"

function CommonHeadingBeforeAfterLine({headingText}) {
  return (
    <section className='CommonHeadingBeforeAfterLine'>
    <div className='section_heading_div'>
          <p className='heading_text'>{headingText}</p>
        </div>
    </section>
  )
}

export default CommonHeadingBeforeAfterLine
